import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import UpdateSleepStoryRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/SleepStoryService/UpdateSleepStoryRequest";
import SleepStoryTranslateViewModel from "./sleepStoryTranslateViewModel";
import SleepStoryDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/SleepStoryService/SleepStoryDetailResponse";
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import VoiceFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/VoiceFileResponse";
import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";


  
export default class CreateSleepStoryViewModel {
    id?: number = null;
	isPaid: boolean = false;
	useOnMainDisplay: boolean = false;
	animationId: string = null;
	animationUrl: string = null;
	translations: Array<SleepStoryTranslateViewModel> = null;
	audios: Array<AudioGroupViewModel> = [];
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	categoriesIds: Array<number> = null;
	setAudio(audioGroup: AudioGroupViewModel) {
		this.translations.forEach(tr => {
			const audio = audioGroup.audios.find(x=>x.langCode == tr.langCode);
			if (audio != null) {
				tr.voiceFile = audio;
			}
		});
	}
	getAudio(): AudioGroupViewModel {
		const langs = this.translations.map(x=>x.langCode);
		const res = new AudioGroupViewModel(langs);
		res.audios = this.translations.map(x=> x.voiceFile);
		res.isPaid = this.translations.every(tr => tr.voiceFile != null && tr.voiceFile.isPaid);
		return res;
	}
	removeAudio() {
		this.translations.forEach(tr => tr.voiceFile = null);
	}
	toServerModel(): UpdateSleepStoryRequest {
		const req = new UpdateSleepStoryRequest({
			Id: this.id,
			IsPaid: this.isPaid,
			AnimationId: this.animationId,
			UseOnMainDisplay: this.useOnMainDisplay,
			Back: mapToCropRequest(this.backgroundImage), // this.coverImage,
			Cover: mapToCropRequest(this.coverImage), // this.coverImage,
			Translations: this.translations.map(x=>x.toServerModel()),
			Categories: this.categoriesIds,
		});
		this.audios.forEach(audioGroup => {
			req.Translations.forEach(tr => {
				const audio = audioGroup.audios.find(x=>x.langCode == tr.LangCode);
				tr.VoiceFile = audio.toServerModel();
			});
		});
		return req;
	}
	fromServerModel(model: SleepStoryDetailResponse) {
		this.id = model.Id;
		this.isPaid = model.IsPaid;
		this.useOnMainDisplay = model.UseOnMainDisplay;
		this.animationId = model.AnimationId;

		const langs = this.translations.map(x => x.langCode);
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
				tr.description = serverTranslation.Description;
			}
		});

		this.categoriesIds = (model.Categories || []).map(x => x.Id);

		this.backgroundImage.ImageUrl = model.BackgroundUrl;
		this.coverImage.ImageUrl = model.CoverUrl;
		this.audios = [new AudioGroupViewModel(langs)];
		this.audios.forEach((audioGroup, i) => {
			audioGroup.audios = [];
			const audios = this.translations.map(x=>{
					const voiceFile = ((model.Translations.find(mt => mt.LangCode == x.langCode) || {}).VoiceFile)
					return {
						langCode: x.langCode,
						file: (voiceFile || new VoiceFileResponse({Url: null}))
				}
			}).filter(x=>x.file!=null);
			if (audios != null && audios.length > 0) {
				audioGroup.audios = audios.map(x=> new MeditationAudioViewModel({
					id: x.file.Id,
					langCode: x.langCode,
					name: x.file.Name,
					isPaid: x.file.IsPaid,
					audioUrl: x.file.Url
				}));
			}
		});
	}
}
